import { render } from "./detail.vue?vue&type=template&id=2abaae28&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=2abaae28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2abaae28"

export default script